/* unplugin-vue-components disabled */import { ElTooltip as __unplugin_components_11 } from 'element-plus/es';import 'element-plus/es/components/tooltip/style/css';
import { ElTag as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import __unplugin_components_9 from '~icons/custom/undone';
import { ElIcon as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_7 from '~icons/custom/completed';
import { ElForm as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElSelect as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElInput as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_0 from '/Users/liao/work/cmge/ultrasdk/ultrasdk.hub.web/packages/base/src/components/GameChannelSelect/index.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6190efdc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex align-items"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "flex align-center"
};
const _hoisted_4 = {
  class: "pluginConf"
};
const _hoisted_5 = {
  class: "userPlugin"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开通状态", -1));
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkCfgChangeChannelStatus, apiUsdkGetChannelConfigList } from '@/api/usdk';
import { copyText } from '@ultra/share/utils';
import { ElMessage, ElMessageBox } from 'element-plus';
import { customDataReport } from '@/utils/dataReport';
export default /*#__PURE__*/_defineComponent({
  __name: 'channelList',
  props: {
    gameInfo: {
      type: Object,
      default: () => ({})
    },
    activePane: {
      type: String,
      default: ''
    }
  },
  emits: ['onActive', 'onCurrentChannel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const columns = [{
      label: '渠道ID',
      prop: 'cid'
    }, {
      label: '渠道名称',
      prop: 'name'
    }, {
      label: '基础配置',
      prop: 'baseConf',
      slot: 'baseConf'
    }, {
      label: '插件配置',
      prop: 'pluginConf',
      slot: 'pluginConf'
    },
    // { label: '打包参数及状态', prop: 'isConf', slot: 'isConf' },
    {
      label: '开通状态',
      prop: 'permission',
      slot: 'permission',
      header: 'perHeader'
    }, {
      label: '操作',
      action: true
    }];
    const ConfOptions = [{
      label: '全部',
      value: ''
    }, {
      label: '配置成功',
      value: true
    }, {
      label: '等待配置',
      value: false
    }];
    const filter = ref({
      isPackage: '',
      active: 1,
      cid: '',
      packageName: ''
    });
    const getTableData = async () => {
      tableLoading.value = true;
      const res = await apiUsdkGetChannelConfigList({
        gid: props.gameInfo.Id,
        ...filter.value
      });
      tableLoading.value = false;
      if (res.code === 0) {
        tableData.value = res.data;
        filterData.value = res.data;
      } else {
        tableData.value = [];
        filterData.value = [];
      }
      handleSearch();
    };
    // 开通/禁用渠道
    const handleToggleChannel = (active, id) => {
      const dict = {
        active: {
          name: '禁用/恢复渠道开关（0：禁用；1: 启用）'
        }
      };
      // 二次确认
      ElMessageBox.confirm(`确认${active === 0 ? '禁用' : '恢复'}该渠道吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return apiUsdkCfgChangeChannelStatus({
          active,
          id
        }).then(res => {
          if (res.code === 0) {
            getTableData();
            customDataReport({
              eventName: 'ban_channel',
              dict,
              before: {
                active: active === 0 ? 1 : 0
              },
              after: {
                active
              },
              operatePath: '出包-渠道配置-禁用/恢复渠道',
              gid: props.gameInfo.Id
            });
          }
        });
      }).catch(() => {
        ElMessage.info('已取消操作');
      });
    };
    let filterFunc = (condition, data) => {
      return data.filter(item => {
        return Object.keys(condition).every(key => {
          return item[key] === condition[key];
        });
      });
    };
    const check = filter => {
      for (let i in filter) {
        if (filter[i] === undefined || filter[i] === '') {
          delete filter[i];
        }
      }
      return filter;
    };
    const filterData = ref([]);
    const handleSearch = () => {
      if (props.activePane === 'channelList') {
        filter.value.active = 1;
      } else if (props.activePane === 'recycleBin') {
        filter.value.active = 0;
      }
      const f = check(JSON.parse(JSON.stringify(filter.value)));
      const res = filterFunc(f, tableData.value);
      filterData.value = res;
    };
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    const handleClick = (type, row) => {
      if (row) {
        emits('onCurrentChannel', row);
      }
      const dict = {
        set: 'channelConf',
        add: 'addChannel',
        pluginConf: 'pluginConf'
      };
      if (type === 'copy') {
        copyText(row.gameUrl).then(() => {
          ElMessage.success('复制成功');
        });
      } else {
        emits('onActive', dict[type]);
      }
    };
    watch(() => props.activePane, val => {
      if (val === 'channelList') {
        getTableData();
      }
      if (val === 'recycleBin') {
        getTableData();
      }
    });
    watch(() => props.gameInfo.Id, val => {
      if (val) {
        getTableData();
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_game_channel_select = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_input = __unplugin_components_2;
      const _component_el_option = __unplugin_components_3;
      const _component_el_select = __unplugin_components_4;
      const _component_el_button = __unplugin_components_5;
      const _component_el_form = __unplugin_components_6;
      const _component_i_custom_completed = __unplugin_components_7;
      const _component_el_icon = __unplugin_components_8;
      const _component_i_custom_undone = __unplugin_components_9;
      const _component_u_question = _resolveComponent("u-question");
      const _component_el_tag = __unplugin_components_10;
      const _component_el_tooltip = __unplugin_components_11;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_form, {
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "渠道名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_game_channel_select, {
            gid: __props.gameInfo.Id,
            "other-props": {
              active: __props.activePane === 'channelList' ? 1 : 0
            },
            modelValue: _unref(filter).cid,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).cid = $event)
          }, null, 8, ["gid", "other-props", "modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "包名"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(filter).packageName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(filter).packageName = $event),
            placeholder: "请输入渠道包名"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "配置状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(filter).isPackage,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(filter).isPackage = $event),
            placeholder: "请选择状态"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(ConfOptions, item => {
              return _createVNode(_component_el_option, {
                key: item.label,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: handleSearch
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(UTable, {
        options: columns,
        data: _unref(filterData),
        loading: _unref(tableLoading),
        "max-height": "calc(100vh - 248px)"
      }, {
        baseConf: _withCtx(({
          scope
        }) => [_createElementVNode("div", _hoisted_1, [scope.row.confStatus.isPackageName && scope.row.confStatus.isParams && scope.row.confStatus.isSign ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          size: "16px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_custom_completed)]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          size: "16px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_custom_undone)]),
          _: 1
        })), _createElementVNode("span", {
          class: "marginL10 cp",
          style: {
            "line-height": "18px",
            "color": "#1989FA"
          },
          onClick: $event => handleClick('set', scope.row)
        }, "配置", 8, _hoisted_2)])]),
        pluginConf: _withCtx(({
          scope
        }) => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(scope.row.usePlugin), 1), _createTextVNode("/ "), _createElementVNode("span", null, _toDisplayString(scope.row.totalPlugin), 1)]), _createElementVNode("span", {
          class: "marginL10 cp",
          style: {
            "color": "#1989FA"
          },
          onClick: $event => handleClick('pluginConf', scope.row)
        }, "配置", 8, _hoisted_6)])]),
        perHeader: _withCtx(() => [_hoisted_7, _createTextVNode(), _createVNode(_component_u_question, {
          content: "付费渠道需联系商务开通"
        })]),
        permission: _withCtx(({
          scope
        }) => [_createVNode(_component_el_tag, {
          type: scope.row.permission ? 'success' : 'danger'
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.permission ? '已开通' : '未开通'), 1)]),
          _: 2
        }, 1032, ["type"])]),
        action: _withCtx(({
          scope
        }) => [scope.row.plat === 2 && __props.activePane === 'channelList' ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          effect: "dark",
          content: "复制H5游戏链接",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            onClick: $event => handleClick('copy', scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("复制")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          link: "",
          type: scope.row.active === 0 ? 'primary' : 'danger',
          onClick: $event => handleToggleChannel(scope.row.active ? 0 : 1, scope.row.id)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.active === 0 ? '恢复' : '禁用'), 1)]),
          _: 2
        }, 1032, ["type", "onClick"])]),
        _: 1
      }, 8, ["data", "loading"])], 64);
    };
  }
});